// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1hDhd","footer":"ModalError_footer__62QDv"};